import React, { useContext, useState } from 'react';
import { Typography } from 'antd';
import { GiCarDoor } from 'react-icons/gi';
import AlertCard from './AlertCard';
import { ALERT_CATEGORY, triggerAlert } from '../../mqtt/aws';
import { SimulatorContext } from 'store/context';

const { Text } = Typography;

const DoorOpenAlert = ({ messageApi, onTriggered }) => {
  const { stsToken: credentials, vehicleSimulatorSettings: { serialNo, vehicleKey } } = useContext(SimulatorContext);
  const [loading, setLoading] = useState(false);

  const triggerDoorAlert = async () => {
    setLoading(true);
    await triggerAlert({ serialNo, vehicleKey, actual: '', threshold: '' }, credentials, ALERT_CATEGORY.DOOR_OPEN_ALERT)
      .then(() => { messageApi.success('Door alert triggered successfully'); onTriggered?.({ success: true, value: null }); })
      .catch(() => { messageApi.error('Failed to trigger door alert'); onTriggered?.({ success: false, value: null }); })
      .finally(() => setLoading(false));
  };

  return (
    <AlertCard
      index={5}
      title="Door Open"
      icon={<GiCarDoor />}
      iconBg="#eff6ff"
      iconColor="#2563eb"
      onTrigger={triggerDoorAlert}
      triggerLabel="Trigger Door Alert"
      loading={loading}
    >
      <div
        style={{
          padding: '10px 12px',
          borderRadius: 8,
          background: '#f0fdf4',
          border: '1px solid #86efac',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#10b981', flexShrink: 0 }} />
        <Text style={{ fontSize: 12, color: '#166534', fontWeight: 500 }}>
          Triggered when any vehicle door is left open
        </Text>
      </div>
    </AlertCard>
  );
};

export default DoorOpenAlert;
